/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown>, due: NonNullable<unknown>, kept: NonNullable<unknown> }} Gdpr_Review_Report_TextInputs */

const cs_gdpr_review_report_text = /** @type {(inputs: Gdpr_Review_Report_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`K anonymizaci by šlo: ${i?.n} · označeno 2,5 r.: ${i?.due} · ponecháno: ${i?.kept}`)
};

const en_gdpr_review_report_text = /** @type {(inputs: Gdpr_Review_Report_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Would be anonymised: ${i?.n} · flagged at 2.5 y: ${i?.due} · kept: ${i?.kept}`)
};

/**
* | output |
* | --- |
* | "Would be anonymised: {n} · flagged at 2.5 y: {due} · kept: {kept}" |
*
* @param {Gdpr_Review_Report_TextInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_review_report_text = /** @type {((inputs: Gdpr_Review_Report_TextInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Review_Report_TextInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_review_report_text(inputs)
	return cs_gdpr_review_report_text(inputs)
});